export const AUTH = 'auth';
export const WALLET = 'wallet';
export const CONTRACT = 'contract';
export const BET_HISTORY = 'betHistory';
export const BLOCKCHAIN_SYNC = 'blockchainSync';
export const LOGOUT_ALERT = 'logoutAlert';
export const CHANNEL_CREATION = 'channelCreation';
export const REQUEST_CHANNEL_CREATE = 'requestChannelCreate';
